export default __webpack_public_path__ + "static/media/Members.a893a32a.png";